import Raven from 'raven-js';
import { getMessagesUtk } from '../../query-params/getMessagesUtk';
// @ts-ignore Untyped import
import { getSelectedThread } from '../../selected-thread/selectors/getSelectedThread';
import { getChannelInstanceId } from '../../selectors/widgetDataSelectors/getChannelInstanceId';
// @ts-ignore Untyped import
import { getChannelInstanceIdFromCurrentThreadHistory } from '../../thread-history/selectors/getChannelInstanceIdFromCurrentThreadHistory';
import { isPersistedThread } from '../../threads/operators/isPersistedThread';
import { getChannelName, getThreadId } from '../../threads/operators/threadGetters';
import { buildCustomerAgentFeedbackMessage } from 'conversations-message-history/customer-agent-feedback-message/operators/buildCustomerAgentFeedbackMessage';
// @ts-ignore Untyped import
import { publishMessage } from './publishMessage';
const captureValidationFailure = (reason, extra) => {
  Raven.captureMessage(`publishFeedbackMessage: ${reason}`, {
    level: 'warning',
    extra
  });
  return null;
};
export const publishFeedbackMessage = ({
  messageId,
  feedbackType,
  redactingFeedbackMessageId
}) => async (dispatch, getState) => {
  const currentThread = getSelectedThread(getState());
  const isPersisted = isPersistedThread(currentThread);
  const threadId = getThreadId(currentThread);
  const channel = getChannelName(currentThread);
  const channelInstanceId = isPersisted && threadId ? getChannelInstanceIdFromCurrentThreadHistory(getState(), threadId) : getChannelInstanceId(getState());
  if (!channelInstanceId) {
    return captureValidationFailure('unable to determine channelInstanceId');
  }
  if (!threadId) {
    return captureValidationFailure('unable to determine threadId');
  }
  if (!channel) {
    return captureValidationFailure('unable to determine channel');
  }
  const senderId = getMessagesUtk();
  if (!senderId) {
    return captureValidationFailure('unable to determine senderId');
  }
  const threadIdForPublish = Number(threadId);
  if (!Number.isFinite(threadIdForPublish)) {
    return captureValidationFailure('threadId must be a finite number', {
      threadId
    });
  }
  const feedbackMessage = buildCustomerAgentFeedbackMessage({
    channelInstanceId,
    senderId,
    messageId,
    feedbackType,
    redactingFeedbackMessageId
  });
  try {
    await dispatch(publishMessage({
      channel,
      message: feedbackMessage,
      threadId: threadIdForPublish
    }));
  } catch (err) {
    Raven.captureException(err);
    return null;
  }
  return feedbackMessage.id;
};